import { render, staticRenderFns } from "./KjpControls.vue?vue&type=template&id=523cf154&scoped=true&"
import script from "./KjpControls.vue?vue&type=script&lang=js&"
export * from "./KjpControls.vue?vue&type=script&lang=js&"
import style0 from "./KjpControls.vue?vue&type=style&index=0&id=523cf154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523cf154",
  null
  
)

export default component.exports